import * as actions from "./actionsType";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  notificationHistoriesLength: 0,
  notificationHistories: [],
  notificationHistory: {},
  notificationHistoryError: "",
  formError: "",
};

export default function NotificationHistoryReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_NOTIFICATION_HISTORY:      
      return { ...state, loading: action.payload };

    case actions.LOADING_NOTIFICATION_HISTORY_BY_ID:
      return { ...state, loadingById: action.payload };

    case actions.SAVE_LOADING_NOTIFICATION_HISTORY:
      return { ...state, saveLoading: action.payload };

    case actions.GET_NOTIFICATION_HISTORY:
      return {
        ...state,
        notificationHistories: action.payload.notificationHistories,
        notificationHistoriesLength: action.payload.notificationHistoriesLength,
      };

    case actions.GET_NOTIFICATION_HISTORY_BY_ID:
      return { ...state, notificationHistory: action.payload };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    case actions.NOTIFICATION_HISTORY_FAIL:
      return { ...state, notificationHistoryError: action.payload };

    default:
      return state;
  }
}
